export default __webpack_public_path__ + "static/media/logo-atf-no-text.0f669ec6.svg";